const successRequest = [201, 201]

export const typesFiles = [
  {
    typeClientFile: 'Паспорт',
    type: 'passport'
  },
  {
    typeClientFile: 'Податковий номер',
    type: 'itn'
  },
  {
    typeClientFile: 'Документи, що підтверджують юридичну особу',
    type: 'legalEntityDocuments'
  },
  {
    typeClientFile: 'Документи, що підтверджують фізичну особу підприємця',
    type: 'individualEntrepreneurDocuments'
  },
  {
    typeClientFile: 'Скан-копія довіреності',
    type: 'scannedCopyPowerAttorney'
  },
  {
    typeClientFile: 'Документ, що підтверджує особистість довіреної особи',
    type: 'documentIdentityTrustee'
  },
  {
    typeClientFile: 'Митні документи',
    type: 'customDocuments'
  },
  {
    typeClientFile: 'Свідоцтво про реєстрацію',
    type: 'registrationCertificate'
  },
  {
    typeClientFile: 'Копія інвойсу',
    type: 'invoiceCopy'
  },
  {
    typeClientFile: 'Екологічний стандарт',
    type: 'ecologicalStandard'
  },

]
export const employeeType = {
  moderation: 'moderation',
  systemic: 'systemic',
  outOfSystem: 'out_of_system'
}

export const statementType = {
  technicalControl: 'technical_control',
  certification: 'certification'
}

export const identityDocument = {
  paperPassport: 'Paper',
  idCard: 'Id card',
  internationalPassport: 'International passport',
  permitForResidence: 'Permit for residence'
}
export const keysForAutoSelectVehicle = ['vehicle_type', 'vehicle_mark', 'vehicle_model',
  'registration_number', 'vehicle_fuel_type', 'vehicle_condition', 'vehicle_transmission_type'
]
export const keysForAutoSelectOwner = []

export const listIdentifiersForMCategory = [1, 20, 22, 21, 2, 23, 25, 24, 3, 26, 28, 27]
export const listIdentifiersForNCategory = [4, 29, 31, 30, 5, 32, 34, 33, 6, 35, 37, 36]
export const listIdentifiersForOCategory = [7, 72, 71, 38, 8, 74, 73, 39, 9, 76, 75, 40, 10, 77, 78, 41]
export const listIdentifiersForLCategory = [
  11, 12, 13, 14, 15, 16, 17, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
  64, 65, 66, 67, 68, 69, 70
]
export const listIdentifiersForM1Category = [1, 20, 22, 21]
export const listIdentifiersForM2Category = [2, 23, 25, 24]
export const listIdentifiersForM3Category = [3, 26, 28, 27]
export const listIdentifiersForN1Category = [4, 29, 31, 30]
export const listIdentifiersForN2Category = [5, 32, 34, 33]
export const listIdentifiersForN3Category = [6, 35, 37, 36]
export const listIdentifiersForO1Category = [7, 38]
export const listIdentifiersForO2Category = [8, 39]
export const listIdentifiersForO3Category = [9, 40]
export const listIdentifiersForO4Category = [10, 41]
export const listIdentifiersForL1Category = [11, 42, 43]
export const listIdentifiersForL2Category = [12, 44, 45]
export const listIdentifiersForL6Category = [16, 58, 59, 60, 61]

export const typeMeasurementInteraction = {
  1: 'zigbee',
  2: 'stands',
  3: 'manual'
}

export const lightMeasurementTypeLight = [
  { id: 'left_dipped', name: 'Ліва фара, ближнє світло', mode: [2, 3], cornerFieldName: 'corner_inclination_left' },
  { id: 'right_dipped', name: 'Права фара, ближнє світло', mode: [6, 7], cornerFieldName: 'corner_inclination_right' },
  { id: 'left_high', name: 'Ліва фара, дальнє світло', mode: [1] },
  { id: 'right_high', name: 'Права фара, дальнє світло', mode: [5] },
  { id: 'left_fog', name: 'Ліва протитуманна фара', mode: [4], cornerFieldName: 'fog_light_corner_left' },
  { id: 'right_fog', name: 'Права протитуманна фара', mode: [8], cornerFieldName: 'fog_light_corner_right' },
]

export const lightMeasurementMode = [
  { id: 2, name: 'Сила світла в зоні меншої освітленості', fieldName: 'low_light_power_beam_left' },
  { id: 3, name: 'Сила світла в зоні більшої освітленості', fieldName: 'high_light_power_beam_left' },
  { id: 6, name: 'Сила світла в зоні меншої освітленості', fieldName: 'low_light_power_beam_right' },
  { id: 7, name: 'Сила світла в зоні більшої освітленості', fieldName: 'high_light_power_beam_right' },
  { id: 1, name: 'Сила світла в зоні більшої освітленості', fieldName: 'left_light_power' },
  { id: 5, name: 'Сила світла в зоні більшої освітленості', fieldName: 'right_light_power' },
  { id: 4, name: 'Сила світла в зоні меншої освітленості', fieldName: 'fog_light_left' },
  { id: 8, name: 'Сила світла в зоні меншої освітленості', fieldName: 'fog_light_right' }
]

export const typesEquipment = {
  zigbee: 1,
  stand: 2,
  manual: 3
}

export const wrongFields = {
  OC: {
    director: ['author', 'director_passport_serial', 'director_passport_inn', 'passport', 'itn'],
    main: ['name', 'short_name', 'address', 'EDPROU', 'code', 'phone_numbers', 'landline_phone', 'web_resource_link',
      'email', 'order_number', 'order_date', 'accreditation_certificate_number', 'accreditation_certificate_date_start',
      'accreditation_certificate_date_end', 'allow_categories', 'accreditationCertificateNAAU',
      'orderMIU', 'spheresAccreditationProject', 'extractFromTheRegisterEDRPOU', 'appointmentOrderOfManager'],
    employee: ['first_name', 'last_name', 'middle_name', 'serial', 'inn', 'position', 'email', 'experience_years',
      'education_document_number', 'educational_institution', 'education_document_issued_date', 'specialization',
      'direction_raising_qualification', 'raising_qualification_document_number', 'raising_qualification_date',
      'educationDocument', 'raisingQualificationDocument', 'identityDocument', 'itn'],
    branch: ['head_full_name', 'address', 'phone_number', 'email'],
    documentField: ['insurance_fields'],
    documentFile: ['insurance']
  },
  VL: {
    director: ['author', 'director_passport_serial', 'director_passport_inn', 'passport', 'itn'],
    main: ['name', 'short_name', 'address', 'EDPROU', 'code', 'phone_numbers', 'landline_phone', 'web_resource_link',
      'email', 'accreditation_certificate_number', 'accreditation_certificate_date_end', 'extractFromTheRegisterEDRPOU',
      'passportVL', 'accreditationCertificateNAAU', 'sphereAccreditation', 'legalDocumentsVL', 'appointmentOrderOfManager'],
    branch: ['name', 'address', 'number', 'allow_categories']
  }
}

export const roleListUserVL = [
  { role: 'Керівник дільниці лабораторії', type_user: 'Section cheif laboratory', access: 'canCreateChief' },
  { role: 'Експерт', type_user: 'Expert laboratory', access: 'canCreateExpert' },
  { role: 'Менеджер лабораторії', type_user: 'Manager laboratory', access: 'canCreateManager' }
]

export const booleanSelectOption = [
  { value: true, name: 'Так' },
  { value: false, name: 'Ні' }
]

export const vehicleClassList = [
  { value: 'I', name: 'I' },
  { value: 'II', name: 'II' },
  { value: 'III', name: 'III' },
  { value: 'A', name: 'A' },
  { value: 'B', name: 'B' },
  { value: 'School', name: 'Шкільний' },
  { value: 'Disabled', name: 'Інвалідний' },
  { value: '-', name: '-' }
]

export const noiseInspectionType = [
  {
    name: 'Нерухомий КТЗ',
    value: 'stationary'
  },
  {
    name: 'Рухомий КТЗ',
    value: 'moving'
  },
]

export const streetTypeAbbr = {
  'clientAddress.typesStreet.street': 'вул.',
  'clientAddress.typesStreet.prospectus': 'просп.',
  'clientAddress.typesStreet.boulevard': 'бульв.',
  'clientAddress.typesStreet.square': 'пл.',
  'clientAddress.typesStreet.maidan': 'майд.',
  'clientAddress.typesStreet.lane': 'пров.',
  'clientAddress.typesStreet.alley': 'алея',
  'clientAddress.typesStreet.highway': 'шосе',
  'clientAddress.typesStreet.trunk': 'маг.',
  'clientAddress.typesStreet.pickUp': 'узвіз',
  'clientAddress.typesStreet.nameAddress': ''
}

export default { successRequest }
